import React from 'react';

const SvgMapNew = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 50 42"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-USPs-MapNew__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-USPs-MapNew__path-1",
  d: "M1.276 6.236L11.866.624a2.4 2.4 0 012.33.046l9.53 5.538a2.4 2.4 0 002.42-.004l9.43-5.527a2.4 2.4 0 012.338-.05l10.577 5.609a2.4 2.4 0 011.275 2.12v29.818a2.4 2.4 0 01-3.524 2.12l-8.328-4.416a2.4 2.4 0 00-2.338.05l-9.426 5.524a2.4 2.4 0 01-2.426 0l-9.436-5.527a2.4 2.4 0 00-2.33-.053l-8.44 4.44A2.4 2.4 0 010 38.19V8.356a2.4 2.4 0 011.276-2.12z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.04 -.12)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-USPs-MapNew__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-USPs-MapNew__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-USPs-MapNew__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M13.056 0h11.827v48.384H13.056zM36.864-.768h18.432v43.776H36.864z",
  mask: "url(#tourlane-USPs-MapNew__mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M36.84 5c2.474 0 4.48 1.935 4.48 4.323 0 1.591-1.493 4.204-4.48 7.837-2.987-3.633-4.48-6.246-4.48-7.838C32.36 6.935 34.366 5 36.84 5zm0 2.787c-.873 0-1.581.68-1.581 1.52s.708 1.52 1.581 1.52 1.581-.68 1.581-1.52-.708-1.52-1.581-1.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  d: "M6.344 25.982l.055.049 1.014 1.014 1.013-1.014a.544.544 0 01.818.713l-.049.056-1.013 1.014 1.013 1.013a.544.544 0 01-.713.818l-.056-.049-1.013-1.013-1.014 1.013a.544.544 0 01-.818-.714l.049-.055 1.014-1.013L5.63 26.8a.544.544 0 01.714-.818zm11.008 2.524c.428.022.849.039 1.263.05a.64.64 0 01-.034 1.28 50.315 50.315 0 01-1.296-.052.64.64 0 11.067-1.278zm6.29-.133a.64.64 0 11.14 1.272c-.425.047-.858.085-1.3.116a.64.64 0 01-.09-1.277c.426-.03.842-.067 1.25-.111zm-11.335-.352c.425.058.844.11 1.258.159a.64.64 0 01-.149 1.271 72.38 72.38 0 01-1.28-.161.64.64 0 01.097-1.275l.074.006zm16.212-.697a.64.64 0 01.42 1.21c-.409.141-.83.271-1.265.39a.64.64 0 11-.337-1.235c.407-.111.801-.233 1.182-.365zm4.262-2.341a.64.64 0 11.823.98c-.341.286-.7.556-1.077.81a.64.64 0 11-.715-1.061c.34-.23.663-.472.97-.73zm2.923-3.877a.64.64 0 111.166.527c-.187.415-.393.814-.618 1.198a.64.64 0 01-1.104-.648c.202-.344.387-.703.556-1.077z"
}))));

export default SvgMapNew;